import React from 'react';
import PropTypes from 'prop-types';
import ShakaPlayer from '../ShakaPlayer';
import { makeFitImageUrlWithSize } from "../../../utils";
import { Typography } from '@material-ui/core';
import Loader from '../../Loader';
import ErrorOutlineIcon from '@material-ui/icons/ErrorOutline';

class EmbeddablePlayer extends React.Component {
  state = {
    contentCreation: this.props.contentCreation,
    loading: false,
    error: null
  };



  componentDidUpdate(prevProps) {
    if (prevProps.contentId !== this.props.contentId) {
      this.setState({
        contentCreation: this.props.contentCreation,
        loading: false,
        error: null
      });
    }
  }

  renderLoading = () => {
    const { width, height } = this.props;
    return (
      <div 
        style={{ 
          display: "flex", 
          justifyContent: "center", 
          alignItems: "center", 
          height: height,
          width: width,
          backgroundColor: '#000'
        }}
      >
        <Loader />
      </div>
    );
  };

  renderError = () => {
    const { width, height } = this.props;
    return (
      <div 
        style={{ 
          display: "flex", 
          flexDirection: "column",
          justifyContent: "center", 
          alignItems: "center", 
          height: height,
          width: width,
          backgroundColor: '#000',
          color: '#fff',
          padding: '20px'
        }}
      >
        <ErrorOutlineIcon style={{ fontSize: 48, color: '#fff', marginBottom: 16 }} />
        <Typography variant="body1" align="center">
          {this.state.error}
        </Typography>
      </div>
    );
  };

  renderAudio = (contentCreation) => {
    const { width, height } = this.props;
    return (
      <audio 
        src={contentCreation.audio.url} 
        controls 
        style={{ width, height }}
      />
    );
  };

  renderVideo = (contentCreation) => {
    const { width, height, autoPlay } = this.props;
    return (
      <ShakaPlayer
        material={contentCreation}
        video={contentCreation.video}
        autoPlay={false}
        subtitles={contentCreation.closedCaptions}
        thumbnail={contentCreation.image 
          ? makeFitImageUrlWithSize(contentCreation, 'lg') 
          : makeFitImageUrlWithSize({image: contentCreation.video}, 'lg')
        }
        videoTitle={contentCreation.title}
        contentCreationId={contentCreation.id}
        style={{ width, height }}
      />
    );
  };

  renderEmbed = (contentCreation) => {
    const { width, height } = this.props;
    const videoId = contentCreation.embededContent.embed_url.split('/');
    let embedUrl;
    
    switch (contentCreation.embededContent.source) {
      case 'youtube':
        embedUrl = `https://www.youtube.com/embed/${videoId[videoId.length - 1]}?modestbranding=1&rel=0&enablejsapi=1`;
        break;
      case 'vimeo':
        embedUrl = `https://player.vimeo.com/video/${videoId[videoId.length - 1]}`;
        break;
      case 'spotify':
        embedUrl = `https://open.spotify.com/embed/${videoId[videoId.length - 2]}/${videoId[videoId.length - 1].split('?')[0]}`;
        break;
      default:
        return null;
    }

    return (
      <iframe
        src={embedUrl}
        width={width}
        height={height}
        frameBorder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowFullScreen
      />
    );
  };

  renderImage = (contentCreation) => {
    const { width, height } = this.props;
    return (
      <img 
        src={makeFitImageUrlWithSize(contentCreation, 'lg')}
        alt={contentCreation.title}
        style={{ 
          width, 
          height,
          objectFit: 'contain'
        }}
      />
    );
  };

  renderContent = () => {
    const { contentCreation } = this.state;

    if (contentCreation.audio) {
      return this.renderAudio(contentCreation);
    }
    
    if (contentCreation.video) {
      return this.renderVideo(contentCreation);
    }

    if (contentCreation.embededContent) {
      return this.renderEmbed(contentCreation);
    }

    return this.renderImage(contentCreation);
  };

  render() {
    const { width, height } = this.props;
    const { loading, error, contentCreation } = this.state;

    if (loading) {
      return this.renderLoading();
    }

    if (error) {
      return this.renderError();
    }

    if (!contentCreation) {
      return null;
    }

    return (
      <div style={{
        width,
        height,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: '#000'
      }}>
        {this.renderContent()}
      </div>
    );
  }
}

EmbeddablePlayer.propTypes = {
  contentId: PropTypes.string.isRequired,
  width: PropTypes.string,
  height: PropTypes.string,
  autoPlay: PropTypes.bool,
};

EmbeddablePlayer.defaultProps = {
  width: '100%',
  height: 'auto',
  autoPlay: false,
};

export default EmbeddablePlayer; 